const Loader = ({ loading }) => {
  return (
    <>
      <section className={loading ? "" : "d-none"}>
        <div className="loader">
          <div className="strip-holder">
            <span
              className="spinner-border spinner-border-lg"
              role="status"
              aria-hidden="true"
            />
            <span style={{ fontSize: "30px" }}>&nbsp; Loading...</span>
          </div>
        </div>
      </section>
    </>
  );
};

export default Loader;
